import Backbone from 'backbone';
import _ from 'underscore';

const eventEmmiter = _.extend({}, Backbone.Events);

export function trigger(ev) {
  return eventEmmiter.trigger(ev);
}

export function on(ev, cb, context) {
  return eventEmmiter.on(ev, cb, context);
}

export function off(ev, cb, context) {
  return eventEmmiter.off(ev, cb, context);
}



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/core/eventEmmiter.js
 **/